var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientApiPrinter
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "../ApiClient";
import { HttpMethod } from "../HttpClient";
/* tslint:disable:no-namespace */
export var FleetOwnerVerificationNoAuthService;
(function (FleetOwnerVerificationNoAuthService) {
    var ApiClientClass = /** @class */ (function (_super) {
        __extends(ApiClientClass, _super);
        function ApiClientClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Generated from: {@link [FleetOwnerPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/controller/FleetOwnerPortalController.ts)} */
            _this.verificationChallenge = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/verificationChallenge",
                            service_id: "fleet-owner-verification",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/controller/FleetOwnerPortalController.ts)} */
            _this.startVerification = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/startVerification",
                            service_id: "fleet-owner-verification",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/controller/FleetOwnerPortalController.ts)} */
            _this.getOtpForm = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getOtpForm",
                            service_id: "fleet-owner-verification",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/controller/FleetOwnerPortalController.ts)} */
            _this.submitOtpForm = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/submitOtpForm",
                            service_id: "fleet-owner-verification",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: false },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            return _this;
        }
        return ApiClientClass;
    }(GeneratedApiClient));
    // Split class actual prototype and type
    FleetOwnerVerificationNoAuthService.ApiClient = ApiClientClass;
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var AlertType;
    (function (AlertType) {
        AlertType["INFO"] = "info";
    })(AlertType = FleetOwnerVerificationNoAuthService.AlertType || (FleetOwnerVerificationNoAuthService.AlertType = {}));
    /** Generated from: {@link [FleetOwnerAuthInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet_owner/FleetOwnerAuthInternalAsyncApi.ts)} */
    var AuthResult;
    (function (AuthResult) {
        AuthResult["SUCCESS"] = "success";
        AuthResult["TWO_FACTOR_REQUIRED"] = "two_factor_required";
        AuthResult["PASSWORD_CHANGE_REQUIRED"] = "password_change_required";
    })(AuthResult = FleetOwnerVerificationNoAuthService.AuthResult || (FleetOwnerVerificationNoAuthService.AuthResult = {}));
    /** Generated from: {@link [BrandHelper.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/util/brand/BrandHelper.ts)} */
    var BrandEnum;
    (function (BrandEnum) {
        BrandEnum["BOLT"] = "bolt";
        BrandEnum["HOPP"] = "hopp";
    })(BrandEnum = FleetOwnerVerificationNoAuthService.BrandEnum || (FleetOwnerVerificationNoAuthService.BrandEnum = {}));
    /** Generated from: {@link [AbusePreventionInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/abuse_prevention/AbusePreventionInternalAsyncApi.ts)} */
    var CaptchaChallengeType;
    (function (CaptchaChallengeType) {
        CaptchaChallengeType["RECAPTCHA_NATIVE"] = "recaptcha_native";
        CaptchaChallengeType["WEBVIEW"] = "webview";
    })(CaptchaChallengeType = FleetOwnerVerificationNoAuthService.CaptchaChallengeType || (FleetOwnerVerificationNoAuthService.CaptchaChallengeType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var ComboBoxAppearance;
    (function (ComboBoxAppearance) {
        ComboBoxAppearance["HEADER_INACTIVE"] = "header_inactive";
        ComboBoxAppearance["COLUMN_SPLIT"] = "column_split";
    })(ComboBoxAppearance = FleetOwnerVerificationNoAuthService.ComboBoxAppearance || (FleetOwnerVerificationNoAuthService.ComboBoxAppearance = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var CustomIcon;
    (function (CustomIcon) {
        CustomIcon["BRIEFCASE"] = "briefcase";
        CustomIcon["BUSINESS_RIDE"] = "business_ride";
    })(CustomIcon = FleetOwnerVerificationNoAuthService.CustomIcon || (FleetOwnerVerificationNoAuthService.CustomIcon = {}));
    /** Generated from: {@link [FormFieldService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/service/FormFieldService.ts)} */
    var DescriptionType;
    (function (DescriptionType) {
        DescriptionType["TEXT"] = "text";
        DescriptionType["CUSTOM_TEXT"] = "custom_text";
        DescriptionType["ALERT"] = "alert";
    })(DescriptionType = FleetOwnerVerificationNoAuthService.DescriptionType || (FleetOwnerVerificationNoAuthService.DescriptionType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var FieldName;
    (function (FieldName) {
        FieldName["COMPANY_NAME"] = "company_name";
        FieldName["FLEET_SIZE"] = "fleet_size";
        FieldName["CITY_ID"] = "city_id";
        FieldName["BILLING_TYPE"] = "billing_type";
        FieldName["PAYOUT_RECIPIENT_TYPE"] = "payout_recipient_type";
        FieldName["ADDRESS"] = "address";
        FieldName["REG_CODE"] = "reg_code";
        FieldName["IS_LIABLE_TO_VAT"] = "is_liable_to_vat";
        FieldName["VAT_CODE"] = "vat_code";
        FieldName["ACCOUNT_RECIPIENT"] = "account_recipient";
        FieldName["ACCOUNT_IBAN"] = "account_iban";
        FieldName["ACCOUNT_SWIFT"] = "account_swift";
        FieldName["TAX_IDENTIFICATION_NUMBER"] = "tax_identification_number";
        FieldName["TAX_IDENTIFICATION_NUMBER_COUNTRY"] = "tax_identification_number_country";
        FieldName["NEW_PASSWORD"] = "new_password";
        FieldName["CURRENT_PASSWORD"] = "current_password";
        FieldName["PHONE_NUMBER"] = "phone_number";
        FieldName["PHONE_COUNTRY_CODE"] = "phone_country_code";
        FieldName["EMAIL"] = "email";
        FieldName["EMAIL_OR_USERNAME"] = "email_or_username";
        FieldName["FIRST_NAME"] = "first_name";
        FieldName["LAST_NAME"] = "last_name";
    })(FieldName = FleetOwnerVerificationNoAuthService.FieldName || (FleetOwnerVerificationNoAuthService.FieldName = {}));
    /** Generated from: {@link [FleetOwnerPortalService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/service/FleetOwnerPortalService.ts)} */
    var FopVerificationChallengeSuccessType;
    (function (FopVerificationChallengeSuccessType) {
        FopVerificationChallengeSuccessType["OTP_REQUESTED"] = "otp_requested";
        FopVerificationChallengeSuccessType["CONTINUE_SIGNUP"] = "continue_signup";
        FopVerificationChallengeSuccessType["ADD_NEW_COMPANY_REGISTRATION"] = "add_new_company_registration";
        FopVerificationChallengeSuccessType["CONTINUE_COMPANY_REGISTRATION_STEPS"] = "continue_company_registration_steps";
        FopVerificationChallengeSuccessType["CONTINUE_COMPANY_REGISTRATION_ONBOARDING_PAGE"] = "continue_company_registration_onboarding_page";
        FopVerificationChallengeSuccessType["USE_SIGNUP"] = "use_signup";
        FopVerificationChallengeSuccessType["USE_AUTH"] = "use_auth";
        FopVerificationChallengeSuccessType["CONTINUE_AUTH"] = "continue_auth";
        FopVerificationChallengeSuccessType["TWO_FACTOR_AUTH_REQUIRED"] = "two_factor_auth_required";
        FopVerificationChallengeSuccessType["TWO_FACTOR_CONFIRMATION_REQUIRED"] = "two_factor_confirmation_required";
    })(FopVerificationChallengeSuccessType = FleetOwnerVerificationNoAuthService.FopVerificationChallengeSuccessType || (FleetOwnerVerificationNoAuthService.FopVerificationChallengeSuccessType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var FormFieldType;
    (function (FormFieldType) {
        FormFieldType["TEXT"] = "text_input";
        FormFieldType["NUMBER"] = "number_input";
        FormFieldType["COMBOBOX"] = "combo_box";
        FormFieldType["CHECKBOX"] = "check_box";
        FormFieldType["CHECKBOXGROUP"] = "check_box_group";
        FormFieldType["RADIOGROUP"] = "radio_group";
        FormFieldType["FILEUPLOAD"] = "file_upload";
        FormFieldType["IMAGEUPLOAD"] = "image_upload";
        FormFieldType["PASSWORD"] = "password";
        FormFieldType["EMAIL"] = "email";
        FormFieldType["INFOTEXT"] = "info_text";
        FormFieldType["INFOTEXTGROUP"] = "info_text_group";
    })(FormFieldType = FleetOwnerVerificationNoAuthService.FormFieldType || (FleetOwnerVerificationNoAuthService.FormFieldType = {}));
    /** Generated from: {@link [FormService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/service/FormService.ts)} */
    var FormType;
    (function (FormType) {
        FormType["SET_PASSWORD"] = "create_password";
        FormType["MATCH_USERNAME_AND_PASSWORD"] = "match_username_and_password";
        FormType["UPDATE_PHONE"] = "update_phone";
        FormType["TWO_FACTOR_AUTH_LOGIN"] = "2fa_login";
        FormType["TWO_FACTOR_AUTH_CONFIRMATION"] = "2fa_confirmation";
    })(FormType = FleetOwnerVerificationNoAuthService.FormType || (FleetOwnerVerificationNoAuthService.FormType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var IconType;
    (function (IconType) {
        IconType["KALEP"] = "kalep";
        IconType["REACT_FLAGS"] = "react_flags";
        IconType["CUSTOM"] = "custom";
    })(IconType = FleetOwnerVerificationNoAuthService.IconType || (FleetOwnerVerificationNoAuthService.IconType = {}));
    /** Generated from: {@link [Types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/constants/Types.ts)} */
    var NonCodeVerificationChannel;
    (function (NonCodeVerificationChannel) {
        NonCodeVerificationChannel["PASSWORD"] = "password";
    })(NonCodeVerificationChannel = FleetOwnerVerificationNoAuthService.NonCodeVerificationChannel || (FleetOwnerVerificationNoAuthService.NonCodeVerificationChannel = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var PasswordValidationType;
    (function (PasswordValidationType) {
        PasswordValidationType["PASSWORD_LENGTH"] = "password_length";
        PasswordValidationType["CONTAIN_UPPER_AND_LOWER_CASE_LETTERS"] = "contain_upper_and_lower_case_letters";
        PasswordValidationType["CONTAIN_NUMBERS"] = "contain_numbers";
    })(PasswordValidationType = FleetOwnerVerificationNoAuthService.PasswordValidationType || (FleetOwnerVerificationNoAuthService.PasswordValidationType = {}));
    /** Generated from: {@link [Types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/constants/Types.ts)} */
    var Source;
    (function (Source) {
        Source["LOGIN"] = "login";
        Source["SIGNUP"] = "signup";
    })(Source = FleetOwnerVerificationNoAuthService.Source || (FleetOwnerVerificationNoAuthService.Source = {}));
    /** Generated from: {@link [FleetOwnerPortalService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/service/FleetOwnerPortalService.ts)} */
    var SubmitOtpFormResult;
    (function (SubmitOtpFormResult) {
        SubmitOtpFormResult["CONTINUE_SIGNUP"] = "continue_signup";
        SubmitOtpFormResult["CONTINUE_TO_ADD_COMPANY_REGISTRATION"] = "continue_to_add_company_registration";
        SubmitOtpFormResult["CONTINUE_TO_ADD_NEW_COMPANY_REGISTRATION"] = "continue_to_add_new_company_registration";
        SubmitOtpFormResult["CONTINUE_TO_COMPANY_REGISTRATION_ONBOARDING_PAGE"] = "continue_to_company_registration_onboarding_page";
        SubmitOtpFormResult["CONTINUE_TO_COMPANY_REGISTRATION_STEPS"] = "continue_to_company_registration_steps";
        SubmitOtpFormResult["CONFIRMATION_REQUIRED"] = "confirmation_required";
        SubmitOtpFormResult["START_AUTHENTICATION_TWO_FACTOR_AUTH_REQUIRED"] = "start_authentication_two_factor_auth_required";
        SubmitOtpFormResult["PASSWORD_CHANGE_REQUIRED"] = "password_change_required";
        SubmitOtpFormResult["FAILURE"] = "failure";
        SubmitOtpFormResult["PHONE_UPDATE_SUCCESS"] = "phone_update_success";
        SubmitOtpFormResult["CONTINUE_TO_PORTAL_LOGGED_IN"] = "continue_to_portal_logged_in";
        SubmitOtpFormResult["TWO_FACTOR_AUTH_LOGIN_REQUIRED"] = "two_factor_auth_login_required";
    })(SubmitOtpFormResult = FleetOwnerVerificationNoAuthService.SubmitOtpFormResult || (FleetOwnerVerificationNoAuthService.SubmitOtpFormResult = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var TextStyle;
    (function (TextStyle) {
        TextStyle["BOLD"] = "bold";
    })(TextStyle = FleetOwnerVerificationNoAuthService.TextStyle || (FleetOwnerVerificationNoAuthService.TextStyle = {}));
    /** Generated from: {@link [FleetOwnerPortalService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/service/FleetOwnerPortalService.ts)} */
    var TwoFactorAuthConfirmationType;
    (function (TwoFactorAuthConfirmationType) {
        TwoFactorAuthConfirmationType["CREATE_NEW_ACCOUNT"] = "create_new_account";
        TwoFactorAuthConfirmationType["CONTINUE_WITH_EXISTING_ACCOUNT"] = "continue_with_existing_account";
    })(TwoFactorAuthConfirmationType = FleetOwnerVerificationNoAuthService.TwoFactorAuthConfirmationType || (FleetOwnerVerificationNoAuthService.TwoFactorAuthConfirmationType = {}));
    /** Generated from: {@link [Types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_verification/main/constants/Types.ts)} */
    var VerificationChannel;
    (function (VerificationChannel) {
        VerificationChannel["SMS"] = "sms";
        VerificationChannel["VOICE"] = "voice";
        VerificationChannel["WHATSAPP"] = "whatsapp";
        VerificationChannel["NONE"] = "none";
    })(VerificationChannel = FleetOwnerVerificationNoAuthService.VerificationChannel || (FleetOwnerVerificationNoAuthService.VerificationChannel = {}));
    /** Generated from: {@link [FleetOwnerAuthInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet_owner/FleetOwnerAuthInternalAsyncApi.ts)} */
    var VerificationCodeChannel;
    (function (VerificationCodeChannel) {
        VerificationCodeChannel["SMS"] = "sms";
        VerificationCodeChannel["CALL"] = "call";
    })(VerificationCodeChannel = FleetOwnerVerificationNoAuthService.VerificationCodeChannel || (FleetOwnerVerificationNoAuthService.VerificationCodeChannel = {}));
})(FleetOwnerVerificationNoAuthService || (FleetOwnerVerificationNoAuthService = {}));
